import { useInfiniteQuery } from '@tanstack/react-query'
import { assistantEffects } from '@/lib/assistant-effects.generated'
import { PolicyBrowserEvents, useRefreshQueriesOn } from '@/lib/browser-events'
import { policyOrderKeys, policyResultKeys } from '../../api/policy-order-api'

import { policyCatalogApi, policyCatalogKeys } from '../../api/policy-catalog-api'

export function usePolicyCatalog(entityId: string) {
  useRefreshQueriesOn(PolicyBrowserEvents.for({ entityId }).changed, [
    policyCatalogKeys.all(entityId), policyOrderKeys.all(entityId), policyResultKeys.all(entityId),
  ], 100)
  return useInfiniteQuery({
    queryKey: policyCatalogKeys.all(entityId),
    queryFn: ({ pageParam }) => policyCatalogApi.list(entityId, pageParam || undefined),
    meta: { assistantEffects: [assistantEffects.settingsChanged] },
    initialPageParam: '',
    getNextPageParam: (page) => page.hasMore ? page.nextCursor : undefined,
  })
}
